import React from "react";

import { Stack, Typography } from "@mui/material";
import { IBookmark } from "store/types";

import { ViewRow } from "./ViewRow";

interface Props {
  label: string;
  isCurrent: boolean;
  bookmarks: IBookmark[];
  onApplied: () => void;
}

export const PageGroup: React.FC<Props> = ({ label, isCurrent, bookmarks, onApplied }) => (
  <Stack>
    <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ padding: "4px 24px" }}>
      <Typography
        sx={{
          fontSize: "12px",
          fontWeight: 600,
          color: "#496682",
          lineHeight: "16px",
          textTransform: "uppercase"
        }}
      >
        {label}
      </Typography>
      {isCurrent && (
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            lineHeight: "16px",
            color: "#071f35",
            backgroundColor: "#f6f8fc",
            padding: "4px 8px",
            borderRadius: "20px"
          }}
        >
          On this page
        </Typography>
      )}
    </Stack>
    {bookmarks.map((bookmark) => (
      <ViewRow key={bookmark.id} bookmark={bookmark} pageLabel={label} onApplied={onApplied} />
    ))}
  </Stack>
);
